import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
interface CaseStudyBandProps {
  title: string;
  description: string;
  year: string;
  imagePosition: 'left' | 'right';
  bgColor: string;
  index: number;
  imageUrl?: string;
  onViewCaseStudy: () => void;
}
export function CaseStudyBand({
  title,
  description,
  year,
  bgColor,
  index,
  imageUrl,
  onViewCaseStudy
}: CaseStudyBandProps) {
  return <section className="w-full py-10 md:py-14 px-8 md:px-16 lg:px-24 overflow-hidden" style={{
    backgroundColor: bgColor
  }} data-id="element-29">
      <motion.div initial={{
      opacity: 0,
      y: 60
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut',
      delay: index * 0.06
    }} className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-30">
        {/* Text Content - always left */}
        <div className="flex flex-col gap-3 order-2 lg:order-1" data-id="element-31">
          <div className="flex items-center gap-4 mb-1" data-id="element-32">
            <span className="text-sm font-bold tracking-widest uppercase text-[#6B6560]" data-id="element-33">
              {year}
            </span>
            <div className="h-px w-12 bg-[#6B6560]/30" data-id="element-34"></div>
          </div>

          <h2 className="text-xl md:text-2xl font-bold text-[#1A1A1A] leading-tight" data-id="element-35">
            {title}
          </h2>

          <p className="text-sm md:text-base text-[#6B6560] leading-relaxed max-w-md" data-id="element-36">
            {description}
          </p>

          <div className="pt-1" data-id="element-37">
            <button onClick={onViewCaseStudy} className="group inline-flex items-center text-[#1A1A1A] font-medium text-base hover:text-[#4A4A4A] transition-colors cursor-pointer gap-[0px]" data-id="element-38">
              View case study
              <span className="ml-2 inline-block transition-transform duration-300 ease-out group-hover:translate-x-2" data-id="element-39">
                <ArrowRightIcon className="w-4 h-4" data-id="element-40" />
              </span>
            </button>
          </div>
        </div>

        {/* Image Card - always right */}
        <div className="order-1 lg:order-2 w-full aspect-[16/10] relative cursor-pointer" onClick={onViewCaseStudy} data-id="element-41">
          <motion.div className="absolute inset-0 bg-[#E8E4DF] rounded-2xl overflow-hidden" style={{
          boxShadow: '0 4px 12px rgba(0,0,0,0.04)'
        }} whileHover={{
          y: -4,
          boxShadow: '0 12px 32px rgba(0,0,0,0.08)'
        }} transition={{
          type: 'tween',
          duration: 0.2,
          ease: 'easeOut'
        }} data-id="element-42">
            {imageUrl ? <>
                <img src={imageUrl} alt={title} className="absolute inset-0 w-full h-full object-cover" data-id="element-43" />
                <div className="absolute inset-0 rounded-2xl img-outline pointer-events-none" data-id="element-44" />
              </> : <div className="absolute inset-0 flex items-center justify-center" data-id="element-45">
                <div className="text-[#6B6560]/40 font-serif italic text-2xl" data-id="element-46">
                  Project Preview
                </div>
              </div>}
          </motion.div>
        </div>
      </motion.div>
    </section>;
}